import { AppCard, AppRemixIcon } from '@/layout/AppComponents';

const FIELD_LABELS = {
  assignmentID: 'ID de asignación',
  state: 'Estado',
  evidenceDate: 'Fecha de evidencia',
  evidence: 'Evidencia',
  responsibles: 'Responsables',
};

export default function GlobalImportResultView({ result, onBack }) {
  const errors = result.errors || [];

  return (
    <section className="content mb-5">
      <AppCard header="Resultado de la importación">
        <div className="row mb-4">
          <div className="col-md-4 mb-2">
            <div className="alert alert-success mb-0">
              Registros actualizados: <strong>{result.updated}</strong>
            </div>
          </div>
          <div className="col-md-4 mb-2">
            <div className="alert alert-secondary mb-0">
              Registros sin cambios: <strong>{result.skipped}</strong>
            </div>
          </div>
          <div className="col-md-4 mb-2">
            <div className="alert alert-danger mb-0">
              Registros con errores: <strong>{result.failed}</strong>
            </div>
          </div>
        </div>
        {errors.length > 0 && (
          <div className="table-responsive">
            <table className="table table-hover table-sm">
              <thead>
                <tr>
                  <th>Fila</th>
                  <th>ID de asignación</th>
                  <th>Campo</th>
                  <th>Valor</th>
                  <th>Motivo</th>
                </tr>
              </thead>
              <tbody>
                {errors.map((error, index) => (
                  <tr
                    key={`${error.row}-${error.assignmentID ?? 'none'}-${index}`}
                  >
                    <td>{error.row}</td>
                    <td>{error.assignmentID ?? '-'}</td>
                    <td>
                      {error.field
                        ? FIELD_LABELS[error.field] || error.field
                        : '-'}
                    </td>
                    <td>{error.value || '-'}</td>
                    <td>{error.message || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <button type="button" className="btn btn-primary mt-3" onClick={onBack}>
          <AppRemixIcon icon="arrow-left" className="mr-2" />
          Volver a evaluación
        </button>
      </AppCard>
    </section>
  );
}
